<template>
    <PropietarioData />
</template>

<script>
import PropietarioData from "./propietario-data";
export default {
    components: {PropietarioData}
}
</script>
